<template>
  <div>
    <div class="partner max-w">
      <div class="title">
        <div class="en">-cluster partner-</div>
        <div class="cn">集群伙伴</div>
      </div>
      <div class="over">
        <div class="info flex">
          <a
            v-for="(item, index) in partner"
            :key="'partant' + index"
            :href="item.link ? item.link : 'javascript:void(0);'"
            :target="item.link ? '_blank' : '_self'"
            class="box"
            ><img :src="item.img" :alt="item.title"
          /></a>
          <div
            class="box no-height"
            v-for="(i, index) in 8"
            :key="'k' + index"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getList } from "@/api/web";
export default {
  Layout: "inside",
  data() {
    return {
      partner: [],
    };
  },
  watch: {
    $route: {
      handler: function () {
        this.getInfo();
      },
    },
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      getList(this.$route.meta.id).then((res) => {
        this.partner = res.data.list;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.partner {
  padding-top: 60px;
  padding-bottom: 60px;
  .title {
    text-align: center;
    .en {
      text-transform: uppercase;
      color: #3d8aff;
      font-weight: lighter;
      font-size: 40px;
      @media only screen and (max-width: 1200px) {
        font-size: 26px;
      }
    }
    .cn {
      font-weight: bold;
      font-size: 24px;
      color: #333333;
      margin-top: 10px;
    }
  }
  .over {
    @media only screen and (max-width: 1200px) {
      overflow-x: auto;
    }
    .info {
      flex-wrap: wrap;
      margin-top: 20px;
      .box {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20%;
        height: 146px;
        img {
          width: 146px;
        }
      }
      .no-height {
        height: 0 !important;
      }
      @media only screen and (max-width: 1200px) {
        .box {
          width: 100px;
          height: 80px;
          img {
            width: 90%;
          }
        }
      }
    }
  }
  @media only screen and (max-width: 1200px) {
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
</style>
